import ROUTES from 'constants/routes';

/**
 * Chemin absolu vers lequel rediriger, relatif à l'origine.
 */
const resolveTargetPath = (returnPath?: string | null): string => {
  const home = `${ROUTES.BASENAME}${ROUTES.HOME}`;

  if (!returnPath) {
    return home;
  }

  if (!returnPath.startsWith('/') || returnPath.startsWith('//')) {
    return home;
  }

  return returnPath;
};

/**
 * Redirige après authentification, par un rechargement complet.
 */
const redirectAfterAuth = (returnPath?: string | null): void => {
  window.location.replace(
    `${window.location.origin}${resolveTargetPath(returnPath)}`,
  );
};

export default redirectAfterAuth;
